/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_404_LeadInputs */

const en_mk_404_lead = /** @type {(inputs: Mk_404_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Right now we only have a full comparison against Multica.`)
};

const id_mk_404_lead = /** @type {(inputs: Mk_404_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saat ini kami baru punya perbandingan lengkap dengan Multica.`)
};

/**
* | output |
* | --- |
* | "Right now we only have a full comparison against Multica." |
*
* @param {Mk_404_LeadInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_404_lead = /** @type {((inputs?: Mk_404_LeadInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_404_LeadInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_404_lead(inputs)
	return en_mk_404_lead(inputs)
});